import CrmApi from '../../../api/crm.js';
import WebsiteDefaultModel from '../../models/Website/WebsiteDefaultModel';

const state = {
  website: WebsiteDefaultModel(),
};

const getters = {
  getRecommendations: (state) => {
    return state.website.recommendations;
  },
  getTeams: (state) => {
    return state.website.teams;
  },
};

const actions = {
  process({ state }) {
    return new Promise((resolve, reject) => {
      CrmApi.processWebsiteData(state.website)
        .then(response => {
          resolve(response);
        }).catch(error => {
        reject(error);
      });
    });
  },

  show({ commit }) {
    commit('setWebsite', {
      ...WebsiteDefaultModel(),
    });

    return new Promise((resolve, reject) => {
      CrmApi.getWebsiteData().then(response => {
        commit('setWebsite', {
          ...WebsiteDefaultModel(),
          ...response.data,
        });
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  deleteRecommendation(state, index) {
    state.website.recommendations.splice(index, 1);
  },
  addRecommendation(state, recommendation) {
    state.website.recommendations.push(recommendation);
  },
  deleteTeam(state, index) {
    state.website.teams.splice(index, 1);
  },
  addTeam(state, team) {
    state.website.teams.push(team);
  },
  setWebsite(state, website) {
    state.website = {
      ...state.website,
      ...website,
      company: {
        ...state.website.company,
        ...website.company,
      },
    };
  },
  updateWebsite(state, payload) {
    state.website = {
      ...state.website,
      ...payload,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
